<div class="header">
  <div class="title">Add Hook</div>
  <button class="close-button" mat-icon-button (click)="saveAndClose()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="createFolderForm">
  <!-- Subject -->
  <mat-form-field class="flex-auto treo-mat-no-subscript">
    <mat-label>Hook</mat-label>
    <mat-select [formControlName]="'hook_name'">
      <mat-option *ngFor="let hookName of hookNames" [value]="hookName">{{ hookName }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="flex-auto treo-mat-no-subscript mt-2">
    <mat-label>Object Type</mat-label>
    <mat-select [formControlName]="'object_type'">
      <mat-option [value]="'Project'">Deal</mat-option>
      <mat-option [value]="'PropertyTenant'">Lease</mat-option>
      <mat-option [value]="'Property'">Property</mat-option>
      <mat-option [value]="'PropertyUnit'">Unit</mat-option>
      <mat-option [value]="'Task'">Task</mat-option>
      <mat-option [value]="'TaskList'">Task List</mat-option>
      <mat-option [value]="'LoanQuote'">Loan Quote</mat-option>
      <mat-option [value]="'FacilityReport'">Facility Report</mat-option>
      <mat-option [value]="'Contact'">Contact</mat-option>
      <mat-option [value]="'Company'">Company</mat-option>
      <mat-option [value]="'Comment'">Comment</mat-option>
      <!-- Custom Objects -->
      <mat-option *ngFor="let customObject of customObjects; trackBy: trackByFn" [value]="customObject.name">{{
        customObject.label | titlecase
      }}</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Body -->

  <div class="actions justify-end">
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        type="submit"
        [color]="'primary'"
        [disabled]="createFolderForm.pristine || createFolderForm.invalid"
        (click)="save()"
      >
        <span>Save</span>
      </button>
    </div>
  </div>
</form>
